import { Box, CheckBox, SpacerNew, TextNew } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { useStores } from '../../data/store'
import { NewEmptyCheckboxes } from './NewEmptyCheckboxes'
import { styles } from './styles'

interface RenderItemProps {
  item: any
  mainIndex: number
  stateArray: any
  isSelectAllChecked: boolean
  isEditMode?: boolean
  cardsRowsSelectionChange: (cardType: string, cardSchemeName: string, rowItem: any, isSelected: boolean) => void
  cardsIndividualCheckChange: (cardType: string, columnName: string, item: any, isSelected: boolean) => void
}

interface CheckboxTextInterface {
  item: any
  isEmpty: boolean
  updateCardTypeChecked: (name: string, isChecked: boolean) => void
  isSelectAllChecked: boolean
  isEditMode?: boolean
}

const CheckboxText = React.memo(
  ({ item, isEmpty, updateCardTypeChecked, isSelectAllChecked, isEditMode }: CheckboxTextInterface) => {
    const { getCardTypeSelection } = useStores((root) => ({
      getCardTypeSelection: root.getCardTypeSelection,
    }))
    const [checked, toggleChecked] = useState(false)

    useEffect(() => {
      const isRowSelected = getCardTypeSelection(item)
      toggleChecked(isRowSelected)
    }, [getCardTypeSelection, item])

    const onChange = (isChecked: string) => {
      updateCardTypeChecked(item?.name, isChecked === 'true')
      toggleChecked(isChecked === 'true')
    }
    return (
      <Box {...styles.mainView(isEmpty)}>
        <CheckBox
          iconSize={20}
          color={isEditMode ? (checked || isSelectAllChecked ? 'BLUE_SHADE' : 'GREY_MATTE') : 'DARK_GREY'}
          checked={checked || isSelectAllChecked}
          onChange={onChange}
          disabled={!isEditMode}
        />
        <SpacerNew size={12} direction="horizontal" />
        <TextNew fontSize={12} color={'BLACK'}>
          {item?.name}
        </TextNew>
      </Box>
    )
  },
)

export const NewRows = React.memo(
  ({
    item,
    mainIndex,
    stateArray,
    isSelectAllChecked,
    isEditMode,
    cardsRowsSelectionChange,
    cardsIndividualCheckChange,
  }: RenderItemProps) => {
    const isEmpty = item?.name?.length < 1
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const deepClonedName = React.useMemo(() => JSON.parse(JSON.stringify(item)), [item, stateArray])

    delete deepClonedName.name //We need only Domestic, International, Platinum
    delete deepClonedName.type
    delete deepClonedName.scheme

    const keysArray = Object.keys(deepClonedName)

    const updateRowChecked = (name: string, isChecked: boolean) => {
      cardsRowsSelectionChange(item.type, item.scheme, item, isChecked)
    }

    return (
      <Box flexDirection={'row'}>
        <CheckboxText
          item={item}
          isEmpty={isEmpty}
          updateCardTypeChecked={updateRowChecked}
          isSelectAllChecked={isSelectAllChecked}
          isEditMode={isEditMode}
        />
        {keysArray?.map((data, index) => {
          return (
            <NewEmptyCheckboxes
              key={index}
              data={deepClonedName}
              name={data}
              childIndex={index}
              mainIndex={mainIndex}
              stateArray={stateArray}
              isEditMode={isEditMode}
              item={item}
              cardsIndividualCheckChange={cardsIndividualCheckChange}
            />
          )
        })}
      </Box>
    )
  },
)
